import { Icon, Loader, Typography } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';

import * as api from '../../api';

import { format } from '../../utils/location';

import styles from './dropdownList.module.css';

interface Props {
  matchedPharmacies: api.Pharmacy.PrevisitPharmacy[];
  nearByPharmacies: api.Pharmacy.PrevisitPharmacy[];
  patientPharmacies: api.Pharmacy.PrevisitPharmacy[];
  inputValue: string;
  onSelect: (id: string) => void;
  pending?: boolean;
}

export const DropDownList = ({
  matchedPharmacies,
  nearByPharmacies,
  patientPharmacies,
  inputValue,
  onSelect,
  pending,
}: Props) => {
  const { t } = useTranslation('pharmacyInput');

  if (inputValue && pending)
    return (
      <div className={styles.DropDownList}>
        <div className={styles.LoaderContainer}>
          <Loader variant={'dot'} color={'gray'} />
        </div>
      </div>
    );

  if (!inputValue && patientPharmacies.length) {
    return (
      <div className={styles.DropDownList}>
        <Title />
        {patientPharmacies.map((patientPharmacy) => (
          <Entry
            pharmacy={patientPharmacy}
            key={patientPharmacy.id}
            onClick={() => onSelect(patientPharmacy.id)}
          />
        ))}
      </div>
    );
  }

  if (matchedPharmacies.length) {
    return (
      <div className={styles.DropDownList}>
        {matchedPharmacies.map((pharmacy) => (
          <Entry
            pharmacy={pharmacy}
            key={pharmacy.id}
            onClick={() => onSelect(pharmacy.id)}
          />
        ))}
      </div>
    );
  }

  if (inputValue) {
    return (
      <div className={styles.DropDownList}>
        <div className={styles.DropdownNoResults}>
          <Icon.AlertTriangle stroke={'#737373'} size="large" />
          <Typography variant={'title-medium'} bold>
            {t('noResults')}
          </Typography>
          <Typography variant={'paragraph-medium'}>
            {t('closePharmacies')}
          </Typography>
        </div>
        <div>
          {nearByPharmacies.map((pharmacy) => (
            <Entry
              pharmacy={pharmacy}
              key={pharmacy.id}
              onClick={() => onSelect(pharmacy.id)}
            />
          ))}
        </div>
      </div>
    );
  }
};

const Title = () => (
  <div className={`${styles.DropdownEntry} ${styles.DropDownTitle}`}>
    <div>
      <Typography variant={'title-medium'} color={'secondary'} bold>
        Previously selected:
      </Typography>
    </div>
  </div>
);

const Entry = ({
  pharmacy,
  onClick,
}: {
  pharmacy: api.Pharmacy.PrevisitPharmacy;
  onClick: () => void;
}) => (
  <div className={styles.DropdownEntry} onClick={onClick}>
    <div>
      <Typography variant={'title-medium'} bold>
        {pharmacy.name}
      </Typography>
      <Typography variant={'paragraph-medium'}>
        {format(pharmacy.address)}
      </Typography>
    </div>
  </div>
);
